import {useEffect, useState} from "react";
import {findStatusIssuedDocuments} from "../../FindStatusIssuedDocuments/findStatusIssuedDocuments";

function useOnShowActiveRoutingOrders(editDoc, cargoCaseDoc) {

    const [isShowActiveRouteOrders, setShowActiveRouteOrders] = useState(false);

 
    useEffect(() => {

        let isMount = true;

            if(editDoc === false && cargoCaseDoc[0]?.bols?.length === 0 && cargoCaseDoc[0]?.manifests?.length === 0) {
                isMount && setShowActiveRouteOrders(true)
            } else if (editDoc === false && cargoCaseDoc[0]?.bols?.length !== 0) {
                if (findStatusIssuedDocuments(cargoCaseDoc[0]?.bols) !== true) {
                    isMount && setShowActiveRouteOrders(true)
                } else {
                    isMount && setShowActiveRouteOrders(false)
                }
            } else if(editDoc === false && cargoCaseDoc[0]?.bols?.length !== 0 && cargoCaseDoc[0]?.manifests?.length !== 0) {
                if (findStatusIssuedDocuments(cargoCaseDoc[0]?.bols) !== true && findStatusIssuedDocuments(cargoCaseDoc[0]?.manifests !== true)) {
                    isMount && setShowActiveRouteOrders(true)
                } else {
                    isMount && setShowActiveRouteOrders(false)
                }
            }

        return () => {
            isMount = false;
        }
    },[editDoc, cargoCaseDoc])

    return {isShowActiveRouteOrders};
}

export default useOnShowActiveRoutingOrders;
